import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { MANAGE_WHITELIST_ZONE } from './url-constants';

type MANAGEWHITELISTZONES = ApiEndpointSpecification;
export const ManageWhitelistZoneEndpointSpecification: MANAGEWHITELISTZONES = {
    url: MANAGE_WHITELIST_ZONE,
    method: HttpMethod.POST,
    requestParamsSchemaName: 'DeviceManageWhitelistZoneRequestParams',
    requestBodySchemaName: 'DeviceManageWhitelistZoneRequestBody',
    okResponseSchemaName: 'DeviceManageWhitelistZoneOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
};

export const invokeManageWhitelistZone = Helpers.makeApiRequestFn<
    Types.DeviceManageWhitelistZoneParams,
    Types.DeviceManageWhitelistZoneRequestBody,
    Types.DeviceManageWhitelistZoneOkResponse
>(ManageWhitelistZoneEndpointSpecification);
